export const LogoMark = ({ className }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#FF6B00" />
    <path
      d="M15 18 L29 32 L15 46"
      fill="none"
      stroke="#080C14"
      strokeWidth="7"
      strokeLinecap="square"
    />
    <path
      d="M31 18 L45 32 L31 46"
      fill="none"
      stroke="#080C14"
      strokeWidth="7"
      strokeLinecap="square"
    />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-9 w-9 shrink-0 transition-transform duration-300 group-hover:-rotate-6 md:h-10 md:w-10" />
    <span className="leading-none">
      <span className="block font-display text-xl font-black tracking-tight text-white md:text-2xl">
        NGCONDE<span className="text-[#FF6B00]">.</span>
      </span>
      {!compact && (
        <span className="mt-1 block font-mono text-[9px] font-medium uppercase tracking-[0.32em] text-slate-400">
          Courier Service · SA
        </span>
      )}
    </span>
  </span>
);
